import React from 'react'

const MenuContent = props => {
  const { menuData } = props
  if (!menuData.data) return null
  const menuHtml = Object.keys(menuData.data).map((item, index) => {
    if (!menuData.data[item].attributes || !menuData.data[item].attributes['html']) return null
      return menuData.data[item].attributes['html']
  })
  if (!menuHtml.length) return null
  return  (
    <div id='menuContent' dangerouslySetInnerHTML={{ __html: menuHtml }} />
  )
}

export default MenuContent



// WEBPACK FOOTER //
// ./shared/_layouts/_templates/_includes/destinations/menuContent.jsx